import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';

@Injectable()

export class PedidosService {


  tabla = 'rest_pedidos_v2';
  data = [];

  constructor(private storage: Storage) {}



  get(): Promise<any>{

    return this.storage.get(this.tabla).then((val) => {

      return JSON.parse(val);
    });

  }



  set(data): Promise<any>{

    this.data = data;

    return this.storage.set(this.tabla, JSON.stringify(data)).then((val) => {

      return this.data;
    });

  }



  delete(){

    this.data = null;
    this.storage.remove(this.tabla);

  }

}



// WEBPACK FOOTER //
// ./src/services/PedidosService.ts